import { IRestaurantFullInfoContext } from './restaurantFullInfoContext';

export enum RestaurantFullInfoActionTypes {
	SET_RESTAURANT_FOR_FULL_INFO = 'SET_RESTAURANT_FOR_FULL_INFO',
	CHANGE_RESTAURANT_FULL_INFO_VISIBLE_FORM = 'CHANGE_RESTAURANT_FULL_INFO_VISIBLE_FORM',
	SET_LOCALIZATION_GROUP = 'SET_LOCALIZATION_GROUP',
	SET_LOCALIZATION_LANGUAGE = 'SET_LOCALIZATION_LANGUAGE',
	SET_LOCALIZATION_DATA = 'SET_LOCALIZATION_DATA',
	SET_STYLE_DATA = 'SET_STYLE_DATA',
	SET_STYLE_GROUP = 'SET_STYLE_GROUP',
	SET_STYLE_LANGUAGE = 'SET_STYLE_LANGUAGE',
	SET_LATEST_SOFTWARE_UPDATE_DATA = 'SET_LATEST_SOFTWARE_UPDATE_DATA',
	SET_REPORT = 'SET_REPORT',
	SET_ANDROID_WATCHES = 'SET_ANDROID_WATCHES',
}

interface IChangeRestaurantFullInfoVisibleForm {
	type: RestaurantFullInfoActionTypes.CHANGE_RESTAURANT_FULL_INFO_VISIBLE_FORM;
	payload: {
		restaurantFullInfoVisibleForm: IRestaurantFullInfoContext['restaurantFullInfoVisibleForm'];
	};
}

interface ISetRestaurantForFullInfo {
	type: RestaurantFullInfoActionTypes.SET_RESTAURANT_FOR_FULL_INFO;
	payload: {
		restaurantForFullInfo: IRestaurantFullInfoContext['restaurantForFullInfo'];
	};
}

interface ISetLocalizationGroup {
	type: RestaurantFullInfoActionTypes.SET_LOCALIZATION_GROUP;
	payload: {
		selectedLocalizationGroup: IRestaurantFullInfoContext['selectedLocalizationGroup'];
	};
}

interface ISetLocalizationLanguage {
	type: RestaurantFullInfoActionTypes.SET_LOCALIZATION_LANGUAGE;
	payload: {
		selectedLocalizationLanguage: IRestaurantFullInfoContext['selectedLocalizationLanguage'];
	};
}

interface ISetLocalizationData {
	type: RestaurantFullInfoActionTypes.SET_LOCALIZATION_DATA;
	payload: {
		localizationData: IRestaurantFullInfoContext['localizationData'];
	};
}

interface ISetStyleData {
	type: RestaurantFullInfoActionTypes.SET_STYLE_DATA;
	payload: {
		styleData: IRestaurantFullInfoContext['styleData'];
	};
}

interface ISetStyleGroup {
	type: RestaurantFullInfoActionTypes.SET_STYLE_GROUP;
	payload: {
		selectedStyleGroup: IRestaurantFullInfoContext['selectedStyleGroup'];
	};
}

interface ISetStyleLanguage {
	type: RestaurantFullInfoActionTypes.SET_STYLE_LANGUAGE;
	payload: {
		selectedStyleLanguage: IRestaurantFullInfoContext['selectedStyleLanguage'];
	};
}

interface ISetLatestSoftwareUpdateData {
	type: RestaurantFullInfoActionTypes.SET_LATEST_SOFTWARE_UPDATE_DATA;
	payload: {
		latestSoftwareUpdateData: IRestaurantFullInfoContext['latestSoftwareUpdateData'];
	};
}

interface ISetReport {
	type: RestaurantFullInfoActionTypes.SET_REPORT;
	payload: {
		report: IRestaurantFullInfoContext['report'];
	};
}

interface ISetAndroidWatches {
	type: RestaurantFullInfoActionTypes.SET_ANDROID_WATCHES;
	payload: {
		androidWatches: IRestaurantFullInfoContext['androidWatches'];
	};
}

export type TRestaurantFullInfoAction =
	| IChangeRestaurantFullInfoVisibleForm
	| ISetRestaurantForFullInfo
	| ISetLocalizationGroup
	| ISetLocalizationLanguage
	| ISetLocalizationData
	| ISetStyleData
	| ISetStyleGroup
	| ISetStyleLanguage
	| ISetLatestSoftwareUpdateData
	| ISetReport
	| ISetAndroidWatches;
